/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_4_PInputs */

const en_terms_4_p = /** @type {(inputs: Terms_4_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free and paid plans and their quotas are described on the pricing page. Paid plans are prepaid for their period and do not renew automatically unless stated at checkout. You can cancel at any time; access continues until the end of the paid period. Because generation costs are incurred immediately, payments are non-refundable except where required by law or when the service was unavailable for a material part of the period.`)
};

const id_terms_4_p = /** @type {(inputs: Terms_4_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paket gratis dan berbayar beserta kuotanya dijelaskan di halaman harga. Paket berbayar dibayar di muka untuk periodenya dan tidak diperpanjang otomatis kecuali dinyatakan saat checkout. Kamu bisa membatalkan kapan saja; akses berlanjut sampai akhir periode yang sudah dibayar. Karena biaya pembuatan langsung timbul, pembayaran tidak dapat dikembalikan kecuali diwajibkan hukum atau layanan tidak tersedia untuk sebagian besar periode.`)
};

/**
* | output |
* | --- |
* | "Free and paid plans and their quotas are described on the pricing page. Paid plans are prepaid for their period and do not renew automatically unless stated ..." |
*
* @param {Terms_4_PInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const terms_4_p = /** @type {((inputs?: Terms_4_PInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_4_PInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_terms_4_p(inputs)
	return en_terms_4_p(inputs)
});